import createModel from '../lib/create_model';

const AssignedTaskResponseReceived = createModel({
  modelName: 'AssignedTaskResponseReceived',

  properties: {
    itemId: String,
    customerId: String,
    taskId: String,
  },
});

export default AssignedTaskResponseReceived;
